export default __webpack_public_path__ + "static/media/12t.f8667456.jpg";